// ── displayName ───────────────────────────────────────────────────────────────
// One place that decides how a person is labelled to OTHERS. NextEp is username-first:
// the @handle is the stable public identity; the display_name is optional and, when
// the user has turned on name-privacy, is never shown to strangers. This is the fix
// for "two strangers become friends but one didn't want to broadcast their last name."
//
// Pass a profile-ish object with { display_name, username, name_private }. Any surface
// that renders someone else's name should route through publicName() so the privacy
// choice is honored consistently.

// The @handle, always safe to show. Falls back gracefully.
export function handle(p) {
  const u = p?.username
  return u ? '@' + u : '@member'
}

// The label to show for a person on public/social surfaces. Honors name-privacy:
// if name_private is on (or there's no display_name), show the @handle instead of a
// possibly-real name.
export function publicName(p) {
  if (!p) return 'Someone'
  if (p.name_private) return handle(p)
  return p.display_name || handle(p)
}

// First name / short label for greetings ("Hey Jason"). Never a full legal name to a
// stranger — for your OWN greeting it's fine to use display_name; callers pass their
// own profile. Splits on space so "Jason Craig" → "Jason".
export function firstName(p, fallback = 'there') {
  const n = p?.display_name || p?.username
  if (!n) return fallback
  return String(n).trim().split(/\s+/)[0] || fallback
}
